export default "__VITE_ASSET__Bvzb47CJ__"